import { render } from "./Home.vue?vue&type=template&id=a80984fe&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=a80984fe&scoped=true&lang=scss"

import exportComponent from "/builds/_flowern/janroedger/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.13_vue@3.5.13_typescript@3.9.7__webpack@4.44.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a80984fe"]])

export default __exports__